/**
 * @deprecated
 */
export default function () {
  if (global['_NIARA_DEFAULT_LOCALE']) return global['_NIARA_DEFAULT_LOCALE']
  if (typeof navigator === 'object' && navigator) {
    if (navigator.language) return navigator.language
    if (navigator.languages && navigator.languages.length) return navigator.languages[0]
  }
  return 'pt-BR'
}
